export default "__VITE_ASSET__GELEBv0O__"